import React, { Component } from 'react'
import bind from 'autobind-decorator'
import { findDOMNode } from 'react-dom'
import styles from './styles'

import Controller from 'app/Components/FormsController'


export default class Input extends Component {
  state = { value: this.props.value || '' }

  componentDidMount() {
    const wrapper = findDOMNode(this)
    const input = wrapper.children[0]
    input.value = Controller[input.name.toLowerCase()]
    this.checkInput(input)
  }

  checkInput(input) {
    const match = input.value.match(/.*/)
    const notEmpty = match[0] !== ''
    this.setState({ active: notEmpty, value: input.value })
  }

  @bind onBlur(event) {
    this.checkInput(event.target)
  }

  @bind onFocus(event) {
    this.setState({ active: true })
  }

  @bind onChange(event) {
    this.checkInput(event.target)
    let field = event.target.name.toLowerCase()
    let value = event.target.value
    Controller.update(field, value)
  }

  className() {
    const classes = [styles.input]
    return classes.join(' ')
  }

  labelClass() {
    const classes = [styles.label]
    if (this.state.active) classes.push(styles.active)
    return classes.join(' ')
  }

  get style() {
    if (typeof this.props.value === 'string') {
      return { display: 'none' }
    }
  }

}



/** WEBPACK FOOTER **
 ** ../app/Components/FormInput/Input.js
 **/